window.COMPARE_MONEY_FORMAT = window.COMPARE_MONEY_FORMAT || null;
const MONEY_FORMAT = null;


function initCompareWhenReady() {
  const clog = () => {};
  const cwarn = () => {};

  const root = document.querySelector('.compare');
  if (!root) {
    cwarn('init aborted: .compare not found');
    return;
  }
  const currentHandle = (root.dataset.currentHandle || '').trim();
  clog('init start', { currentHandle });

  function formatWithDelimiters(number, precision, thousands, decimal) {
    const precisionNum = Number.isFinite(precision) ? precision : 2;
    const thousandsSep = thousands || ',';
    const decimalSep = decimal || '.';

    if (number === null || number === undefined || Number.isNaN(Number(number))) return '0';

    const amount = (Number(number) / 100).toFixed(precisionNum);
    const parts = amount.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousandsSep}`);
    const cents = parts[1] ? (decimalSep + parts[1]) : '';
    return dollars + cents;
  }

  function fallbackFormatMoney(cents, format) {
    const formatString = format || MONEY_FORMAT || '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatFromPlaceholder(placeholder) {
      switch (placeholder) {
        case 'amount':
          return formatWithDelimiters(cents, 2);
        case 'amount_no_decimals':
          return formatWithDelimiters(cents, 0);
        case 'amount_with_comma_separator':
          return formatWithDelimiters(cents, 2, '.', ',');
        case 'amount_with_space_separator':
          return formatWithDelimiters(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(cents, 0, '.', ',');
        case 'amount_no_decimals_with_space_separator':
          return formatWithDelimiters(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator':
          return formatWithDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_apostrophe_separator':
          return formatWithDelimiters(cents, 0, "'", '.');
        default:
          return formatWithDelimiters(cents, 2);
      }
    }

    return formatString.replace(placeholderRegex, (_, token) => formatFromPlaceholder(token));
  }

  function resolveMoneyFormat() {
    const themeMoneyFormat =
      window.theme &&
      window.theme.strings &&
      window.theme.strings.moneyFormat
        ? window.theme.strings.moneyFormat
        : '';

    const pageflyMoneyFormat =
      window.__pagefly_setting__ &&
      window.__pagefly_setting__.moneyFormat
        ? window.__pagefly_setting__.moneyFormat
        : '';

    return (
      MONEY_FORMAT ||
      themeMoneyFormat ||
      pageflyMoneyFormat ||
      (window.Shopify && window.Shopify.money_format) ||
      ''
    );
  }

  function formatMoneySafe(cents) {
    const moneyFormat = resolveMoneyFormat();

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        const formatted = window.Shopify.formatMoney(cents, moneyFormat);
        if (formatted !== undefined && formatted !== null && String(formatted).trim() !== '') {
          return formatted;
        }
      } catch (error) {
        cwarn('Shopify.formatMoney failed, fallback used', error);
      }
    }

    return fallbackFormatMoney(cents, moneyFormat);
  }

  const selects = root.querySelectorAll('.product_select');
  clog('selects found', selects.length);

  /* ================= CLEAR:BOTH SCRUBBER =================
     Some builders (e.g., PageFly) inject <div style="clear:both"></div>
     which breaks grid gaps. We remove/hide them efficiently for 10s.
  ================= */

  function isClearBothDiv(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.tagName !== 'DIV') return false;

    const style = el.getAttribute('style');
    if (!style) return false;

    return /clear\s*:\s*both/i.test(style);
  }

  function hideClearBoth(el) {
    if (!el || el.dataset.clearedByScript) return;
    el.style.display = 'none';
    el.dataset.clearedByScript = 'true';
  }

  function scrubExistingClearBoth(scope) {
    if (!scope || !scope.querySelectorAll) return;

    // Narrow selector first, then validate precisely.
    scope.querySelectorAll('div[style*="clear"]').forEach((el) => {
      if (isClearBothDiv(el)) hideClearBoth(el);
    });
  }

  function startClearBothScrubber() {
    const scope = root; // only inside compare popup
    if (!scope) return;

    // 1) One-time scrub for current DOM
    scrubExistingClearBoth(scope);

    // 2) Only process newly added nodes (no full rescans each tick)
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!node || node.nodeType !== 1) continue;

          // If the added node is the clear:both div itself
          if (isClearBothDiv(node)) {
            hideClearBoth(node);
            continue;
          }

          // Or it may contain one (builder injects wrappers)
          if (node.querySelectorAll) {
            node.querySelectorAll('div[style*="clear"]').forEach((el) => {
              if (isClearBothDiv(el)) hideClearBoth(el);
            });
          }
        }
      }
    });

    mo.observe(scope, { childList: true, subtree: true });

    // 3) Auto stop after 10s
    setTimeout(() => mo.disconnect(), 10000);
  }

  /* ================= IMAGE PRELOAD ================= */
  const preloadedImages = new Set();
  function preloadImage(src) {
    if (!src || preloadedImages.has(src)) return;
    const img = new Image();
    img.src = src;
    preloadedImages.add(src);
  }

  function preloadOptionAssets(option) {
    if (!option || !option.dataset) return;

    // Product image
    preloadImage(option.dataset.image);

    // Flavor swatch image
    preloadImage(option.dataset.flavorImage);

    // Icons driven by settings/schema
    preloadImage(option.dataset.preparationIcon);
    preloadImage(option.dataset.occasionIcon);

    // Per-type form icon (static URL)
    preloadImage(option.dataset.productFormIcon);
  }

  /* ================= PLACEHOLDER ================= */
  function normalizeOptionTitle(option) {
    if (!option || !option.dataset || !option.dataset.title) return;

    const title = option.dataset.title;

    // Keep both textContent and label in sync (some browsers prefer .label)
    if (option.textContent !== title) option.textContent = title;
    if (option.label !== title) option.label = title;
  }

  function updateSelectPlaceholder(select, option) {
    const column = select.closest('.column');
    if (!column) return;

    const placeholder = column.querySelector('[data-product-title]');
    if (!placeholder) return;

    // HARD GUARD – nikdy nečíst text z option
    if (
            !option ||
            option.hasAttribute('data-placeholder') ||
            !option.dataset ||
            !option.dataset.title
    ) {
      placeholder.textContent = '—';
      return;
    }

    normalizeOptionTitle(option);

    placeholder.textContent = option.dataset.title;
  }

  /* ================= BINÁRNÍ BOX (vegan / glutenfree) ================= */
  function updateBinaryBox({ column, key, isTrue, invert = false }) {
    const box = column.querySelector(`[data-product-${key}]`);
    if (!box) return;

    const icon = box.querySelector('img');
    const text = box.querySelector('.main-info');

    const visible = invert ? !isTrue : isTrue;

    if (visible) {
      box.classList.remove('is-empty');

      if (icon) icon.style.display = '';
      if (text) {
        if (text.dataset.original) {
          text.textContent = text.dataset.original;
        }
      }
    } else {
      box.classList.add('is-empty');

      if (icon) icon.style.display = 'none';

      if (key === 'glutenfree') {
        box.classList.add('is-hidden');
      } else if (text) {
        if (!text.dataset.original) {
          text.dataset.original = text.textContent;
        }
      }
    }

    // SPECIÁLNÍ LOGIKA PRO LEPEK:
    // pokud produkt NENÍ gluten free, zobrazíme gluten box místo pomlčky
    if (key === 'glutenfree') {
      const glutenBox = column.querySelector('[data-product-gluten]');
      if (!glutenBox) return;

      if (isTrue) {
        // gluten free = skrýt gluten box
        glutenBox.classList.add('is-hidden');
      } else {
        // obsahuje lepek = zobrazit gluten box
        glutenBox.classList.remove('is-hidden');
      }
    }
  }

  /* ================= HLAVNÍ UPDATE SLOUPCE ================= */
  function updateColumnByIndex(index, option) {
    const wrappers = root.querySelectorAll('.wrapper');

    wrappers.forEach(wrapper => {
      const column = wrapper.querySelectorAll('.column')[index];
      if (!column) return;

      // IMPORTANT: the sticky selector columns contain the <select> and <option>s.
      // Those <option> elements also have many data-* attributes (e.g. data-product-portion),
      // so generic selectors like `[data-product-portion]` can accidentally match the OPTION
      // and overwrite its visible label (this is where the stray "86 g" came from).
      // We never want to populate comparison rows inside the selector columns.
      if (column.classList.contains('select-wrapper')) return;

      /* IMAGE */
      const img = column.querySelector('[data-product-image]');
      if (img && option.dataset.image) img.src = option.dataset.image;

      /* PRICES */
      const portionPrice = column.querySelector('[data-portion-price]');
      const portionPriceSub = column.querySelector('[data-portion-price-subscription]');
      const totalPrice = column.querySelector('[data-product-total-price]');

      const rawPrice = Number(option.dataset.price);
      const subPrice = Number(option.dataset.priceSubscription);
      const servings = Number(option.dataset.servings) || 1;

      const notAvailableText = root.dataset.translationNotAvailable || '—';
      clog('pricing input', {
        index,
        handle: option.dataset && option.dataset.handle,
        rawPrice,
        subPrice,
        servings
      });

      if (Number.isFinite(rawPrice) && rawPrice > 0 && servings > 0) {
        if (portionPrice) {
          portionPrice.innerHTML = formatMoneySafe(Math.round(rawPrice / servings));
        }

        if (Number.isFinite(subPrice) && subPrice > 0) {
          if (portionPriceSub) {
            portionPriceSub.innerHTML = formatMoneySafe(Math.round(subPrice / servings));
            portionPriceSub.classList.add('orange');
          }
          if (totalPrice) totalPrice.innerHTML = formatMoneySafe(subPrice);
        } else {
          if (portionPriceSub) {
            portionPriceSub.textContent = notAvailableText;
            portionPriceSub.classList.remove('orange');
          }
          if (totalPrice) totalPrice.innerHTML = formatMoneySafe(rawPrice);
        }
      } else {
        if (portionPrice) portionPrice.textContent = notAvailableText;
        if (portionPriceSub) portionPriceSub.textContent = notAvailableText;
        if (totalPrice) totalPrice.textContent = notAvailableText;
      }

      /* NUTRITION */
      const map = {
        calories: 'calories',
        protein: 'productProtein',
        fat: 'productFat',
        carbs: 'productCarbs',
        vitamin: 'productVitamin',
        benefits: 'productBenefits'
      };

      Object.entries(map).forEach(([attr, ds]) => {
        const el = column.querySelector(`[data-product-${attr}]`);
        if (!el) return;

        const v = option.dataset[ds];
        el.textContent = (v !== undefined && v !== null && String(v).trim() !== '') ? v : '—';
      });

      /* VERSION LOGO */
      const versionLogo = column.querySelector('[data-product-version-logo]');
      if (versionLogo) {
        const versionLogoSrc = option.dataset.versionLogo || '';
        versionLogo.hidden = !versionLogoSrc;
        versionLogo.alt = option.dataset.versionLogoAlt || '';
        if (versionLogoSrc) versionLogo.src = versionLogoSrc;
        else versionLogo.removeAttribute('src');
        versionLogo.onload = syncCompareVersionLogos;
        syncCompareVersionLogos();
      }

      /* CATEGORY */
      const categoryEl = column.querySelector('[data-product-category-description]');
      if (categoryEl) {
        categoryEl.textContent =
                option.dataset.categoryDescription ||
                option.dataset.category ||
                '';
      }

      /* BUY URL */
      const buyUrlEl = column.querySelector('[data-product-page-url]');
      const productUrl = option.dataset.url || '#';

      if (buyUrlEl) {
        buyUrlEl.href = productUrl;
      }

      /* FULL LABEL URL (always product URL + ?popup=label) */
      const fullLabelLink = column.querySelector('[data-full-label-link]');
      if (fullLabelLink && productUrl && productUrl !== '#') {
        fullLabelLink.dataset.url = productUrl;
        fullLabelLink.href = `${productUrl}?popup=label`;
      }
      if (fullLabelLink) fullLabelLink.dataset.nutritionPdfs = option.dataset.nutritionPdfs || '';

      /* PRODUCT INFO */
      // In-package block (scope selectors to avoid matching OPTION elements)
      const servingEl = column.querySelector('.bord-wrapper [data-product-serving]');
      if (servingEl) servingEl.textContent = option.dataset.servings || '1';

      const portionEl = column.querySelector('.bord-wrapper [data-product-portion]');
      if (portionEl) portionEl.textContent = option.dataset.productPortion || '—';

      const formEl = column.querySelector('[data-product-productForm]');
      if (formEl) formEl.textContent = option.dataset.productFormText || '—';

      const formDescEl = column.querySelector('[data-product-productFormDesc]');
      if (formDescEl) formDescEl.textContent = option.dataset.productFormDescription || '—';

      const formIconEl = column.querySelector('[data-product-productFormIcon]');
      if (formIconEl) {
        const src = option.dataset.productFormIcon;
        if (src) {
          formIconEl.src = src;
          formIconEl.style.display = '';
        } else {
          formIconEl.removeAttribute('src');
          formIconEl.style.display = 'none';
        }
      }

      const expLabelEl = column.querySelector('[data-product-expiracy-label]');
      if (expLabelEl) expLabelEl.textContent = option.dataset.expirationLabel || '—';

      const expEl = column.querySelector('[data-product-expiracy-date]');
      if (expEl) expEl.textContent = option.dataset.expiration || '—';

      const prepEl = column.querySelector('[data-product-productPrep]');
      if (prepEl) prepEl.textContent = option.dataset.preparationText || '—';

      const prepIconEl = column.querySelector('[data-product-productPrepIcon]');
      if (prepIconEl) {
        const src = option.dataset.preparationIcon;
        if (src) {
          prepIconEl.src = src;
          prepIconEl.style.display = '';
        } else {
          prepIconEl.removeAttribute('src');
          prepIconEl.style.display = 'none';
        }
      }

      const occEl = column.querySelector('[data-product-productOccasion]');
      if (occEl) occEl.textContent = option.dataset.occasionText || '—';

      const occIconEl = column.querySelector('[data-product-productOccasionIcon]');
      if (occIconEl) {
        const src = option.dataset.occasionIcon;
        if (src) {
          occIconEl.src = src;
          occIconEl.style.display = '';
        } else {
          occIconEl.removeAttribute('src');
          occIconEl.style.display = 'none';
        }
      }

      /* FLAVOR */
      const flavorCircle = column.querySelector('[data-product-flavor-icon]');
      const flavorDesc = column.querySelector('[data-product-flavor-description]');

      if (flavorDesc) flavorDesc.textContent = option.dataset.flavorName || '—';

      if (flavorCircle) {
        if (option.dataset.flavorImage) {
          flavorCircle.style.background = `url(${option.dataset.flavorImage}) center / cover no-repeat`;
        } else if (option.dataset.flavorColor) {
          flavorCircle.style.background = option.dataset.flavorColor;
        } else {
          flavorCircle.style.background = 'transparent';
        }
      }

      /* VEGAN / GLUTENFREE */
      updateBinaryBox({
        column,
        key: 'glutenfree',
        isTrue: option.dataset.productGlutenfree === 'true'
      });

      updateBinaryBox({
        column,
        key: 'vegan',
        isTrue: option.dataset.productVegan === 'true',
        invert: true
      });
    });
  }

  /* ================= EVENTS ================= */
  selects.forEach((select, index) => {
    select.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      if (!opt) return;
      clog('select change', { index, value: opt.value, title: opt.dataset && opt.dataset.title });

      preloadOptionAssets(opt);
      updateSelectPlaceholder(select, opt);
      updateColumnByIndex(index, opt);
    });
  });


  /* ================= INIT ================= */
  // Normalize all option labels once (prevents stray text like "86 g" in some browsers)
  function normalizeAllOptionLabels() {
    root.querySelectorAll('.product_select option').forEach((o) => {
      if (!o || o.hasAttribute('data-placeholder') || !o.value) return;
      normalizeOptionTitle(o);
    });
  }

  function initializeCompareColumns(attempt = 0) {
    let hasPendingSelects = false;

    normalizeAllOptionLabels();

    selects.forEach((select, index) => {
      const allOptions = Array.from(select.options).filter(o =>
              o &&
              o.value &&
              !o.hasAttribute('data-placeholder') &&
              !o.disabled
      );

      if (!allOptions.length) {
        hasPendingSelects = true;
        cwarn('no options in select', { index, attempt });
        return;
      }

      const defaultCollectionHandle = (select.dataset.defaultCollectionHandle || '').trim();
      const optionsInDefaultCollection = defaultCollectionHandle
        ? allOptions.filter(o => (o.dataset.collectionHandle || '').trim() === defaultCollectionHandle)
        : [];

      let opt = null;

      // 1) First product from selector's configured collection.
      if (optionsInDefaultCollection.length) {
        opt = optionsInDefaultCollection[0];
      }

      // 2) Final fallback: first available option.
      if (!opt) {
        opt = allOptions[0] || null;
      }

      if (!opt) {
        hasPendingSelects = true;
        return;
      }

      select.value = opt.value;

      normalizeOptionTitle(opt);
      updateSelectPlaceholder(select, opt);
      updateColumnByIndex(index, opt);
      preloadOptionAssets(opt);
      clog('init selected', { index, value: opt.value, title: opt.dataset && opt.dataset.title });
    });

    if (hasPendingSelects && attempt < 12) {
      clog('init retry', { nextAttempt: attempt + 1 });
      setTimeout(() => initializeCompareColumns(attempt + 1), 120);
    }
  }

  initializeCompareColumns();

  // Some stores/plugins rehydrate native <select> state after our init.
  // Re-sync displayed compare columns from the currently selected options.
  function syncColumnsFromCurrentSelections() {
    clog('sync selections');
    selects.forEach((select, index) => {
      const validOptions = Array.from(select.options).filter(o =>
              o &&
              o.value &&
              !o.hasAttribute('data-placeholder') &&
              !o.disabled
      );

      let opt = select.selectedOptions && select.selectedOptions[0]
              ? select.selectedOptions[0]
              : null;

      if (!opt || opt.hasAttribute('data-placeholder') || !opt.value) {
        const defaultCollectionHandle = (select.dataset.defaultCollectionHandle || '').trim();
        if (defaultCollectionHandle) {
          opt = validOptions.find(o => (o.dataset.collectionHandle || '').trim() === defaultCollectionHandle) || null;
        }
        if (!opt) {
          opt = validOptions[0] || null;
        }
        if (opt) select.value = opt.value;
      }

      if (!opt) return;

      normalizeOptionTitle(opt);
      updateSelectPlaceholder(select, opt);
      updateColumnByIndex(index, opt);
      preloadOptionAssets(opt);
      clog('sync selected', { index, value: opt.value, title: opt.dataset && opt.dataset.title });
    });
  }

  syncColumnsFromCurrentSelections();
  setTimeout(syncColumnsFromCurrentSelections, 120);
  setTimeout(syncColumnsFromCurrentSelections, 400);
  setTimeout(syncColumnsFromCurrentSelections, 900);

  window.refreshCompareColumns = function () {
    clog('refreshCompareColumns called');
    initializeCompareColumns();
    syncColumnsFromCurrentSelections();
  };

  document.addEventListener('buy-section-popup:opened', () => {
    clog('buy-section-popup:opened');
    setTimeout(() => {
      if (typeof window.refreshCompareColumns === 'function') {
        window.refreshCompareColumns();
      }
    }, 50);
    setTimeout(() => {
      if (typeof window.refreshCompareColumns === 'function') {
        window.refreshCompareColumns();
      }
    }, 220);
  });

  /* ================= BACKGROUND PRELOAD ================= */
  const preloadAllImages = () => {
    root.querySelectorAll('.product_select option').forEach((o) => {
      if (!o || o.hasAttribute('data-placeholder') || !o.value) return;
      preloadOptionAssets(o);
    });
  };

  if ('requestIdleCallback' in window) requestIdleCallback(preloadAllImages);
  else setTimeout(preloadAllImages, 1200);

  startClearBothScrubber();
}

(function waitForComparePopup() {
  const observer = new MutationObserver(() => {
    const root = document.querySelector('.compare');
    if (!root) return;
    observer.disconnect();
    initCompareWhenReady();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

/* FULL LABEL LINK: open the package PDF popup on top of the compare popup when available,
   otherwise fall back to the product URL with ?popup=label. */
document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-full-label-link]');
  if (!link || typeof window.openNutritionPackagePopup !== 'function') return;

  const pdfs = (link.dataset.nutritionPdfs || '')
    .split('||')
    .filter(Boolean)
    .map(item => {
      const [url, handle] = item.split('::');
      return { url, handle };
    })
    .filter(item => item.url);

  if (!pdfs.length) return;
  event.preventDefault();
  window.openNutritionPackagePopup(pdfs, link);
});

/* VERSION LOGO SPACER: keep rows aligned when only some columns have a logo */
function syncCompareVersionLogos() {
  const logos = Array.from(document.querySelectorAll('[data-product-version-logo]'));
  const filled = logos.filter((img) => img.getAttribute('src'));
  const empty = logos.filter((img) => !img.getAttribute('src'));

  filled.forEach((img) => {
    img.classList.remove('version-logo--empty');
    img.style.height = '';
  });

  if (!filled.length) {
    empty.forEach((img) => {
      img.hidden = true;
      img.classList.remove('version-logo--empty');
      img.style.height = '';
    });
    return;
  }

  const maxHeight = Math.max(0, ...filled.map((img) => img.offsetHeight));
  empty.forEach((img) => {
    img.hidden = false;
    img.classList.add('version-logo--empty');
    img.style.height = maxHeight + 'px';
  });
}

window.addEventListener('resize', syncCompareVersionLogos);

